<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div class="row">
            <div class="col-12  mt-2 py-0">
              <h4 class="m-0 p-0 text-secondary d-inline">{{dicts.label_head_troubleshoot[dicts.lang]}}</h4>
              <button class="float-right btn btn-primary shadow mt-2" v-on:click="formTroubleshootActive=!formTroubleshootActive">{{dicts.label_add_troubleshoot[dicts.lang]}}</button>
            </div>
            <transition name="fade">
            <div class="col-12  my-2 py-0" v-if="formTroubleshootActive">
                <div class="row p-3 mx-2 bg-white shadow">
                    <div class="col-12 mb-3">
                        <h4 class="my-0 py-0">{{dicts.label_form_troubleshoot_baru[dicts.lang]}}</h4>
                        <hr>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">SN<span style="color:red;">*</span></label>
                        <smart-search init url="/api/seeker/sold-hardware-setup" :label-tag="['id_transmitter']" key-tag="id_transmitter" v-on:update="(data)=>smartSearchAddIdTransmitter(data)" :search-value="newhardwareidlabel" @update-direct="(label)=>newhardwareidlabel=label"></smart-search>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">MAC Adress</label>
                        <div class="form-control w-100 rounded">{{selectedHardwareSetup.serial_number!=undefined&&selectedHardwareSetup.serial_number != null?selectedHardwareSetup.serial_number.serial_number:'-'}}</div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">ODP</label>
                        <div class="form-control w-100 rounded">{{selectedHardwareSetup.jb!=undefined&&selectedHardwareSetup.jb != null?selectedHardwareSetup.jb.serial_number:'-'}}</div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Nama</label>
                        <div class="form-control w-100 rounded">{{selectedHardwareSetup.vessel!=undefined&&selectedHardwareSetup.vessel.client.legal_name != null?selectedHardwareSetup.vessel.client.legal_name:'-'}}</div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">CID</label>
                        <div class="form-control w-100 rounded">{{selectedHardwareSetup.vessel!=undefined&&selectedHardwareSetup.vessel.name != null?selectedHardwareSetup.vessel.name:'-'}}</div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">{{dicts.label_keluhan[dicts.lang]}} <span style="color:red;">*</span></label>
                        <smart-search init url="/api/master/seeker/troubleshoot-complaint" :label-tag="['complaint_name']" key-tag="complaint_name" v-on:update="(data)=>smartSearchAddComplaint(data)" :search-value="newcomplaintlabel" @update-direct="(label)=>newcomplaintlabel=label"></smart-search>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Status</label>
                        <smart-select name="status" :options="statusTroubleshoot" v-on:update="updateStatus"></smart-select>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">{{dicts.label_start_date[dicts.lang]}} <span style="color:red;">*</span></label>
                        <b-form-datepicker today-button reset-button close-button locale="id" :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}" id="datepicker-start-date" class="mb-2" v-model="newTroubleshoot.startDate"></b-form-datepicker>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">{{dicts.label_technisian[dicts.lang]}}</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newTroubleshoot.technicianName" readonly />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">{{dicts.label_location[dicts.lang]}}</label>
                        <smart-search init url="/api/master/seeker/troubleshoot-location" :label-tag="['location_name']" key-tag="location_name" v-on:update="(data)=>smartSearchAddLocation(data)" :search-value="newlocationlabel" @update-direct="(label)=>newlocationlabel=label"></smart-search>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">{{dicts.label_keterangan[dicts.lang]}}</label>
                        <textarea type="text"  class="form-control w-100 rounded" v-model="newTroubleshoot.notes" />
                    </div>
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="newSaved">
                            <div class="alert alert-success" role="alert">
                                Berhasil menyimpan troubleshoot baru.
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="errorNew">
                            <div class="alert alert-danger" role="alert">
                                <div class="my-0">
                                    <p  class="d-block mt-1">{{createErrorMessage}}</p>
                                </div>
                                <div v-for="err in errorList" v-bind:key="err" class="my-0">
                                    <p  v-for="note in err" v-bind:key="note" class="d-block mt-1 w-100">{{note}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="d-flex align-items-center justify-content-start" v-if="savingNew">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                        </div>
                        <button class="btn btn-primary float-right" type="button" v-on:click="saveNewTroubleshoot">{{dicts.label_simpan[dicts.lang]}}</button>
                    </div>
                </div>
            </div>
            </transition>

        
          <div class="col-12  my-2 py-0">
            <datatable noborder :lang="dicts.lang" :datas="troubleshoots" :structure="TableStructure" :init="loadData" use-seeker ="/api/seeker/troubleshoot" @searching="(val)=>!val.status?getTroubleshoots():troubleshoots=val.data.data" :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}" @refetch="(row)=>{rowLimit=row;getTroubleshoots()}" @change-url="(url)=>getTroubleshoots(url+(url.includes('?')?'&':'?')+'limit='+rowLimit)">
                <template #customcell={obj,index}>
                    <td v-if="isMobile" class="py-3">
                        <ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
                            <li class="border-0" :class="[obj.status=='Close'?'bg-warning':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow':'',obj.status=='Cancel'?'bg-secondary':'']">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">Nomor SN:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.hardware_setup!=null?obj.hardware_setup.serial_number.serial_number:'-' }}</b>
                                </div>
                            </li>
                            <li li class="border-0" :class="[obj.status=='Close'?'bg-warning':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow':'',obj.status=='Cancel'?'bg-secondary':'']">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">ID transmitter:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.hardware_setup!=null?obj.hardware_setup.id_transmitter:'-' }}</b>
                                </div>
                            </li>
                            <li li class="border-0" :class="[obj.status=='Close'?'bg-warning':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow':'',obj.status=='Cancel'?'bg-secondary':'']">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">Nomor JB:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.hardware_setup!=null?obj.hardware_setup.jb.serial_number:'-' }}</b>
                                </div>
                            </li>
                            <li li class="border-0" :class="[obj.status=='Close'?'bg-warning':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow':'',obj.status=='Cancel'?'bg-secondary':'']">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">{{dicts.label_vessel_name[dicts.lang]}}:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.hardware_setup!=null?obj.hardware_setup.vessel.name:'-' }}</b>
                                </div>
                            </li>
                            <li li class="border-0" :class="[obj.status=='Close'?'bg-warning':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow':'',obj.status=='Cancel'?'bg-secondary':'']">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">{{dicts.label_complaint[dicts.lang]}}:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.complaint!=null?obj.complaint:'-' }}</b>
                                </div>
                            </li>
                            <li li class="border-0" :class="[obj.status=='Close'?'bg-warning':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow':'',obj.status=='Cancel'?'bg-secondary':'']">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">Status:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.status }}</b>
                                </div>
                            </li>
                            <li li class="border-0" :class="[obj.status=='Close'?'bg-warning':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow':'',obj.status=='Cancel'?'bg-secondary':'']">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">{{dicts.label_start_date[dicts.lang]}}:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.start_date | timeformat }}</b>
                                </div>
                            </li>
                            <li li class="border-0" :class="[obj.status=='Close'?'bg-warning':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow':'',obj.status=='Cancel'?'bg-secondary':'']">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">{{dicts.label_end_date[dicts.lang]}}:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.end_date | timeformat }}</b>
                                </div>
                            </li>
                            <li>
                                <div class="text-left mx-3 mt-2 pt-0">
                                    <b-button v-b-modal.modal-detail-pengguna class="btn bg-white btn-primary mb-1 mr-2" v-on:click="selectedDetail=index" v-if="['petugas'].includes(role)"><b-icon icon="eye"></b-icon></b-button>
                                    <!-- <b-button v-b-modal.modal-edit-troubleshoot class="btn bg-white btn-info mb-1 mr-2" v-on:click="selectedTroubleshoot=index;dataEdit=Object.assign({},obj)" v-if="checkRoleUpdate(obj)"><b-icon icon="pencil-square"></b-icon></b-button> -->
                                    <b-button v-b-modal.modal-edit-troubleshoot class="btn bg-white btn-info mb-1 mr-2" v-on:click="selectedTroubleshoot=index;dataEdit=Object.assign({},obj)" v-if="checkRoleUpdate(obj)">
                                        <b-icon icon="pencil-square"></b-icon>
                                    </b-button>
                                    <b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj" class="btn bg-white btn-danger mb-1 mr-2" v-if="checkRoleDelete(obj)"><b-icon icon="trash"></b-icon></b-button>
                                </div>
                            </li>
                        </ul>
                    </td>
                    <td v-if="!isMobile" class="border-0" :class="[obj.status=='Close'?'bg-orange':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow ':'',obj.status=='Cancel'?'bg-secondary':'']">{{ index+ 1 }}</td>
                    <td v-if="!isMobile" class="border-0"  :class="[obj.status=='Close'?'bg-orange':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow ':'',obj.status=='Cancel'?'bg-secondary':'']">{{ obj.hardware_setup!=null?obj.hardware_setup.serial_number.serial_number:'-' }}</td>
                    <td v-if="!isMobile" class="border-0"  :class="[obj.status=='Close'?'bg-orange':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow ':'',obj.status=='Cancel'?'bg-secondary':'']">{{ obj.hardware_setup!=null?obj.hardware_setup.id_transmitter:'-' }}</td>
                    <td v-if="!isMobile" class="border-0"  :class="[obj.status=='Close'?'bg-orange':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow ':'',obj.status=='Cancel'?'bg-secondary':'']">{{ obj.hardware_setup!=null?obj.hardware_setup.jb.serial_number:'-' }}</td>
                    <td v-if="!isMobile" class="border-0"  :class="[obj.status=='Close'?'bg-orange':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow ':'',obj.status=='Cancel'?'bg-secondary':'']">{{ obj.hardware_setup!=null?obj.hardware_setup.vessel.name:'-' }}</td>
                    <td v-if="!isMobile" class="border-0"  :class="[obj.status=='Close'?'bg-orange':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow ':'',obj.status=='Cancel'?'bg-secondary':'']">{{ obj.complaint!=null?obj.complaint:'-' }}</td>
                    <td v-if="!isMobile" class="border-0"  :class="[obj.status=='Close'?'bg-orange':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow ':'',obj.status=='Cancel'?'bg-secondary':'']">{{ obj.status }}</td>
                    <td v-if="!isMobile" class="border-0"  :class="[obj.status=='Close'?'bg-orange':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow ':'',obj.status=='Cancel'?'bg-secondary':'']">{{ obj.start_date | timeformat }}</td>
                    <td v-if="!isMobile" class="border-0"  :class="[obj.status=='Close'?'bg-orange':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow ':'',obj.status=='Cancel'?'bg-secondary':'']">{{ obj.end_date | timeformat}}</td>
                    <td v-if="!isMobile" class="border-0"  :class="[obj.status=='Close'?'bg-orange':'',obj.status=='Open'?'bg-green':'',obj.status=='Pending'?'bg-yellow ':'',obj.status=='Cancel'?'bg-secondary':'']">
                        <b-button v-b-modal.modal-detail-pengguna class="btn bg-white btn-primary mb-1 mr-2" v-on:click="selectedDetail=index"><b-icon icon="eye"></b-icon></b-button>
                        <b-button v-b-modal.modal-edit-troubleshoot class="btn bg-white btn-info mb-1 mr-2" v-on:click="selectedTroubleshoot=index;dataEdit=Object.assign({},obj)" v-if="checkRoleUpdate(obj)"><b-icon icon="pencil-square"></b-icon></b-button>
                        <b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj" class="btn bg-white btn-danger mb-1 mr-2" v-if="checkRoleDelete(obj)"><b-icon icon="trash"></b-icon></b-button>
                    </td>
                </template>
            </datatable>
          </div>

        <b-modal no-close-on-esc  content-class="m-0"  title="Detail troubleshoot" id="modal-detail-pengguna" scrollable no-close-on-backdrop @hide="detailModalClose">
            <b-container fluid v-if="!loadData&&troubleshoots.length>0">
                <b-row class="pt-1" v-if="troubleshoots[selectedDetail]!=undefined">
                <b-col cols="12">
                        <table v-if="troubleshoots.length>0" rules="rows" class="table w-100" style="overflow-x:auto;">
                            <tbody>
                                <tr>
                                    <th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt" colspan="2" scope="row">Detail troubleshoot</th>
                                </tr>
                                <tr>
                                    <th class="" scope="row">ID transmitter</th>
                                    <td class="">{{ troubleshoots[selectedDetail].hardware_setup!=null?troubleshoots[selectedDetail].hardware_setup.id_transmitter:'-' }}</td>
                                </tr>
                                <tr>
                                    <th class="" scope="row">Nomor SN</th>
                                    <td class="">{{ troubleshoots[selectedDetail].hardware_setup!=null?troubleshoots[selectedDetail].hardware_setup.serial_number.serial_number:'-' }}</td>
                                </tr>
                                <tr>
                                    <th class="" scope="row">Nomor JB</th>
                                    <td class="">{{ troubleshoots[selectedDetail].hardware_setup!=null?troubleshoots[selectedDetail].hardware_setup.jb.serial_number:'-' }}</td>
                                </tr>
                                <tr>
                                    <th class="" scope="row">Nomor JB baru</th>
                                    <td class="">{{ troubleshoots[selectedDetail].new_jb }}</td>
                                </tr>
                                <tr>
                                    <th class="" scope="row">{{dicts.label_vessel_name[dicts.lang]}}</th>
                                    <td class="">{{ troubleshoots[selectedDetail].hardware_setup!=null?troubleshoots[selectedDetail].hardware_setup.vessel.name:'-' }}</td>
                                </tr>
                                <tr>
                                    <th class="" scope="row">{{dicts.label_client[dicts.lang]}}</th>
                                    <td class="">{{ troubleshoots[selectedDetail].hardware_setup!=null?troubleshoots[selectedDetail].hardware_setup.vessel.client.legal_name:'-' }}</td>
                                </tr>
                                <tr>
                                    <th class="" scope="row">{{dicts.label_complaint[dicts.lang]}}</th>
                                    <td class="">{{ troubleshoots[selectedDetail].complaint!=null?troubleshoots[selectedDetail].complaint:'-' }}</td>
                                </tr>
                                <tr>
                                    <th class="" scope="row">Status</th>
                                    <td class="">{{ troubleshoots[selectedDetail].status }}</td>
                                </tr>
                                <tr>
                                    <th class="" scope="row">{{dicts.label_start_date[dicts.lang]}}</th>
                                    <td class="">{{ troubleshoots[selectedDetail].start_date | timeformat }}</td>
                                </tr>
                                <tr>
                                    <th class="" scope="row">{{dicts.label_end_date[dicts.lang]}}</th>
                                    <td class="">{{ troubleshoots[selectedDetail].end_date | timeformat }}</td>
                                </tr>
                                <tr>
                                    <th class="" scope="row">{{dicts.label_technisian[dicts.lang]}}</th>
                                    <td class="">{{ troubleshoots[selectedDetail].technician_name }}</td>
                                </tr>
                                <tr>
                                    <th class="" scope="row">{{dicts.label_location[dicts.lang]}}</th>
                                    <td class="">{{ troubleshoots[selectedDetail].location!=null?troubleshoots[selectedDetail].location.location_name:'-' }}</td>
                                </tr>
                                <tr>
                                    <th class="" scope="row">{{dicts.label_keterangan[dicts.lang]}}</th>
                                    <td class="">{{ troubleshoots[selectedDetail].notes }}</td>
                                </tr>
                                <tr>
                                    <th class="" scope="row">{{dicts.label_solusi[dicts.lang]}}</th>
                                    <td class="">{{ troubleshoots[selectedDetail].solution }}</td>
                                </tr>
                                
                            </tbody>
                            
                        </table>
                </b-col>
                </b-row>
            </b-container>
            <template #modal-footer>
                <div class="w-100 text-right m-0 p-0">
                <hr>
                <b-button class="btn btn-secondary" @click="(!deleteTroubelshootState)?$bvModal.hide('modal-detail-pengguna'):''">{{dicts.label_tutup[dicts.lang]}}</b-button>
                </div>
            </template>
        </b-modal>

         <b-modal no-close-on-esc  content-class="m-0"  id="modal-edit-troubleshoot" title="Edit troubleshoot" scrollable no-close-on-backdrop size="lg" @hide="editModalClose">
            <b-container fluid v-if="!loadData&&troubleshoots.length>0">
                <b-row class="pt-1" v-if="troubleshoots[selectedTroubleshoot]!=undefined">
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">ID transmitter</label>
                        <div class="form-control w-100 rounded">{{troubleshoots[selectedTroubleshoot].hardware_setup != null?troubleshoots[selectedTroubleshoot].hardware_setup.id_transmitter:'-'}}</div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Nomor SN</label>
                        <div class="form-control w-100 rounded">{{troubleshoots[selectedTroubleshoot].hardware_setup != null?troubleshoots[selectedTroubleshoot].hardware_setup.serial_number.serial_number:'-'}}</div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Nomor JB</label>
                        <div class="form-control w-100 rounded">{{troubleshoots[selectedTroubleshoot].hardware_setup != null?troubleshoots[selectedTroubleshoot].hardware_setup.jb.serial_number:'-'}}</div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">{{dicts.label_vessel_name[dicts.lang]}}</label>
                        <div class="form-control w-100 rounded">{{troubleshoots[selectedTroubleshoot].hardware_setup != null?troubleshoots[selectedTroubleshoot].hardware_setup.vessel.name:'-'}}</div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">{{dicts.label_client[dicts.lang]}}</label>
                        <div class="form-control w-100 rounded">{{troubleshoots[selectedTroubleshoot].hardware_setup != null?troubleshoots[selectedTroubleshoot].hardware_setup.vessel.client.legal_name:'-'}}</div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Nomor JB baru</label>
                        <input type="text" class="form-control w-100 rounded" v-model="troubleshoots[selectedTroubleshoot].new_jb">
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">{{dicts.label_complaint[dicts.lang]}}</label>
                        <smart-search init url="/api/master/seeker/troubleshoot-complaint" usedefault :default-value="troubleshoots[selectedTroubleshoot].complaint" @clear="smartSearchUpdateComplaint(null)" key-tag="complaint_name" :label-tag="['complaint_name']" v-on:update="(data)=>smartSearchUpdateComplaint(data)" ></smart-search>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Status</label>
                        <smart-select name="status" :options="statusTroubleshoot" usedefault :default-value="troubleshoots[selectedTroubleshoot].status" v-on:update="(value)=>{troubleshoots[selectedTroubleshoot].status=value}"></smart-select>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">{{dicts.label_start_date[dicts.lang]}}</label>
                        <b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-start-date" v-model="troubleshoots[selectedTroubleshoot].start_date" class="mb-2">{{troubleshoots[selectedTroubleshoot].start_date}}</b-form-datepicker>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">{{dicts.label_end_date[dicts.lang]}}</label>
                        <b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-end-date" v-model="troubleshoots[selectedTroubleshoot].end_date" class="mb-2">{{troubleshoots[selectedTroubleshoot].end_date}}</b-form-datepicker>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">{{dicts.label_technisian[dicts.lang]}}</label>
                        <div class="form-control w-100 rounded">{{troubleshoots[selectedTroubleshoot].technician_name!=undefined&&troubleshoots[selectedTroubleshoot].technician_name != null?troubleshoots[selectedTroubleshoot].technician_name:'-'}}</div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">{{dicts.label_location[dicts.lang]}}</label>
                        <smart-search init url="/api/master/seeker/troubleshoot-location" usedefault :default-value="troubleshoots[selectedTroubleshoot].location!=null?troubleshoots[selectedTroubleshoot].location.location_name:''" @clear="smartSearchUpdateLocation(null)" key-tag="location_name" :label-tag="['location_name']" v-on:update="(data)=>smartSearchUpdateLocation(data)" ></smart-search>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">{{dicts.label_keterangan[dicts.lang]}}</label>
                        <textarea type="text"  class="form-control w-100 rounded" v-model="troubleshoots[selectedTroubleshoot].notes" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">{{dicts.label_solusi[dicts.lang]}}</label>
                        <textarea type="text"  class="form-control w-100 rounded" v-model="troubleshoots[selectedTroubleshoot].solution" />
                    </div>
                    
                    <b-col cols="12" class="my-3 text-right"  v-if="updateTroubleshootState">
                    <div class="d-flex align-items-center justify-content-start">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                        </div>
                    </b-col>
                    <div class="col-12 mt-3"  v-if="updateTroubleshootSaved">
                        <div class="w-100 align-items-center justify-content-start">
                            <div class="alert alert-success" role="alert">
                                Berhasil update data troubleshoot.
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3"  v-if="errorTroubleshootSaved">
                        <div class="w-100 align-items-center justify-content-start">
                            <div class="alert alert-danger" role="alert">
                                Gagal update data troubleshoot.
                            </div>
                        </div>
                    </div>
                    <b-col cols="12" class="my-3 text-right">
                        <button class="btn btn-info" v-on:click="updateTroubleshootData">{{dicts.label_simpan[dicts.lang]}}</button>
                    </b-col>
                </b-row>
            </b-container>
            <template #modal-footer>
                <div class="w-100 text-right m-0 p-0">
                <hr>
                <b-button class="btn btn-secondary mr-2" @click="(!updateTroubleshootState)?$bvModal.hide('modal-edit-troubleshoot'):''">{{dicts.label_tutup[dicts.lang]}}</b-button>
                <!-- <button class="btn btn-info" v-on:click="updateTroubleshootData">submit</button> -->
                </div>
            </template>
        </b-modal>
        <modal-delete url="/api/troubleshoot/" @read="()=>{console.log('modal ready')}" @result="deleteResult" :targetid="deleteId">
        {{dicts.label_desc_delete[dicts.lang]}} :<br>
        <ul>
            <li>ID Transmitter: {{ itemToDelete.hardware_setup!=null?itemToDelete.hardware_setup.id_transmitter:'-' }}</li>
        </ul>
        </modal-delete>


      </div>
    </div>
  </div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
    import {EventBus} from '../eventbus';
    import * as axios from 'axios';
    import Datatable from '../components/Datatable.vue';
    import SmartSelect from '../components/SmartSelect.vue';
    import SmartSearch from '../components/SmartSearch.vue';
    import ModalDelete from '../components/ModalDelete.vue';
    export default {
        components: {
        //   LTable,
        //   ChartCard,
        //   StatsCard
            'datatable':Datatable,
            'smart-select':SmartSelect,
            'smart-search':SmartSearch,
            'modal-delete':ModalDelete,
        },
        data () {
            return {
                rowLimit:10,
                nextUrl:null,
                prevUrl:null,
                newhardwareidlabel:'',
                newlocationlabel:'',
                newcomplaintlabel:'',
                selectedDetail:0,
                isMobile:false,
                dataEdit:null,//step 1 edit
                deleteId:0,
                createErrorMessage:'Gagal Menyimpan troubleshoot Baru.',
                errorMessages:[],
                itemToDelete:{},
                troubleshoots:[],
                searchValue:'',
                loadData:true,
                savingNew:false,
                errorNew:false,
                errorList:[],
                errorTroubleshootSaved:false,
                existingClientResult:[],
                newSaved:false,
                updateTroubleshootState:false,
                updateTroubleshootSaved:false,
                selectedTroubleshoot:0,
                selectedTab:0,
                updateClientCol:6,
                role:'',
                selectedHardwareSetup:{},
                newTroubleshoot:{
                    hardwareId:'',
                    technicianName:'',
                    startDate:'',
                    endDate:'',
                    status:'Open',
                    notes:'',
                    solution:'',
                    locationId:'',
                    complaint:'',
                },
                formTroubleshootActive:false,
                TableStructure:[
                    //label: nama heading, key: nama object property
                    {label:'No',key:null},
                    {label:'Nama',key:null},
                    {label:'CID',key:null},
                    {label:'ODP',key:null},
                    {label:'SN',key:null},
                    {label:'MAC Address',key:null},
                    {
                      label:{
                        id:'Keluhan',
                        en:'Complaint'
                      },
                      key:null
                    },
                    {label:'Status',key:null},
                    {
                        label:{
                        id:'Tanggal mulai',
                        en:'Start date'
                      },
                      key:null
                    },
                    {
                        label:{
                        id:'Tanggal selesai',
                        en:'End date'
                      },
                      key:null
                    },
                    {
                        label:{
                        id:'Tindakan',
                        en:'Action'
                        },
                        key:null
                    },
                ],
                dicts:{
                    lang:'id',
                    label_head_troubleshoot:{
                        id:'Perbaikan',
                        en:'Troubleshoot'
                    },
                    label_add_troubleshoot:{
                        id:'Tambah troubleshoot baru',
                        en:'Add troubleshoot'
                    },
                    label_form_troubleshoot_baru:{
                        id:'Form troubleshoot baru',
                        en:'New troubleshoot form'
                    },
                    label_client:{
                        id:'Pemilik',
                        en:'Client'
                    },
                    label_start_date:{
                        id:'Tanggal mulai perbaikan',
                        en:'Troubleshoot start date'
                    },
                    label_end_date:{
                        id:'Tanggal selesai perbaikan',
                        en:'Troubleshoot end date'
                    },
                    label_solusi:{
                        id:'Solusi',
                        en:'Solutions'
                    },
                    label_keterangan:{
                        id:'Keterangan',
                        en:'Notes'
                    },
                    label_keluhan:{
                        id:'Keluhan',
                        en:'Complaint'
                    },
                    label_simpan:{
                        id:'Simpan',
                        en:'Submit'
                    },
                    label_technisian:{
                        id:'Teknisi',
                        en:'Technisian'
                    },
                    label_tutup:{
                        id:'Tutup',
                        en:'Close'
                    },
                    label_desc_delete:{
                        id:'Yakin mau menghapus data dengan detail berikut',
                        en:'You are sure you want to delete data with the following details'
                    },
                    label_vessel_name:{
                        id:'Nama kapal',
                        en:'Vessel name'
                    },
                    label_complaint:{
                        id:'Keluhan',
                        en:'Complaint'
                    },
                    label_location:{
                        id:'Lokasi perbaikan',
                        en:'Troubleshoot location'
                    }
                },
                statusTroubleshoot:[
                    {label:'Open',value:'Open'},
                    {label:'Pending',value:'Pending'},
                    {label:'Close',value:'Close'},
                ],
            }
        },
        created(){
            console.clear()
            this.$reActivateAccess(this) /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
            this.role=localStorage.getItem('role');
            console.log('page trable ',this.role);
            this.getTroubleshoots();
            this.isMobile = this.$isMobile
            window.addEventListener('resize', ()=>{
                console.log('screen update')
                this.isMobile = screen.width < 768
            });
            this.newTroubleshoot.technicianName = localStorage.getItem("currentUser");
            this.dicts.lang = localStorage.getItem('lang');
            EventBus.$on('lang',()=>{
                console.log('changing troubleshoot lang')
                this.dicts.lang = localStorage.getItem('lang');
            })
            // var newData = [];
            // for(var x=0;x<100;x++){
            //     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
            // }
            // console.log(newData);
            // this.users = newData;
        },
        methods:{
            changePage(isNext){
                this.getUsers(isNext?this.nextUrl:this.prevUrl)
            },
            updateStatus(data){
                this.newTroubleshoot.status=data
            },
            smartSearchAddIdTransmitter(data){
                this.newTroubleshoot.hardwareId = data.id
                this.selectedHardwareSetup=data
                console.log(this.selectedHardwareSetup)
            },
            checkRoleUpdate(obj){
                if (this.role == 'petugas') {
                    if (obj.status == 'Pending' || obj.status == 'Close') {
                        return false;
                    }else{
                        return true;
                    }
                }else{
                    return true;
                }
            },
            checkRoleDelete(obj){
                if (this.role == 'petugas') {
                    return false;
                }else if (this.role == 'admin') {
                    return true;
                }else if (this.role == 'master_admin') {
                    return true;
                }
            },
            smartSearchAddLocation(data){
                this.newTroubleshoot.locationId = data.id
            },
            smartSearchAddComplaint(data){
                this.newTroubleshoot.complaint = data.complaint_name
            },
            smartSearchUpdateLocation(data){
                this.troubleshoots[this.selectedTroubleshoot].location_id=data.id
            },
            smartSearchUpdateComplaint(data){
                this.troubleshoots[this.selectedTroubleshoot].complaint=data.complaint_name
            },
            deleteResult(deleted){
                console.log(deleted)
                if(deleted){
                    this.getTroubleshoots();
                }
            },
            getTroubleshoots(url=(this.$baseUrl+'/api/troubleshoot?limit='+this.rowLimit)){
                this.loadData=true
                axios.get(url,{'headers':{
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                    console.log(result)
                    this.troubleshoots = result.data.data;
                    this.loadData=false
                }).catch((err)=>{
                    //check if token fail
                    if(err.response && err.response.status==401){
                        localStorage.removeItem('accessToken')
                    this.$router.push('/login')
                    }
                    console.log(err)
                    this.loadData=false
                })
            },
            saveNewTroubleshoot(){
                this.savingNew=true
                this.errorNew=false
                console.log(this.newTroubleshoot)
                if(this.newTroubleshoot.hardwareId!='' && this.newTroubleshoot.startDate ){
                    axios.post(this.$baseUrl+'/api/troubleshoot',
                    {
                        'hardware_setup_id':this.newTroubleshoot.hardwareId,
                        'technician_name':this.newTroubleshoot.technicianName,
                        'start_date':this.newTroubleshoot.startDate,
                        'end_date':this.newTroubleshoot.endDate,
                        'status':this.newTroubleshoot.status,
                        'notes':this.newTroubleshoot.notes,
                        'solution':this.newTroubleshoot.solution,
                        'location_id':this.newTroubleshoot.locationId,
                        'complaint':this.newTroubleshoot.complaint
                    },
                    {
                        'headers':
                        {
                            'Authorization':'Bearer '+localStorage.getItem('accessToken')
                        }
                    }).then((result)=>{
                        console.log(result)
                        this.getTroubleshoots()
                        this.savingNew=false
                        this.newSaved=true
                        setTimeout(() => {
                            this.newSaved=false
                            this.formTroubleshootActive=false
                        }, 1000);

                    }).catch((err)=>{
                        //check if token fail
                        if(err.response && err.response.status==401){
                            localStorage.removeItem('accessToken')
                        this.$router.push('/login')
                        }
                        console.log(err.response)
                        this.errorList=[]
                        this.errorList=Object.values(err.response.data.errors)
                        console.log(this.errorList)
                        this.errorNew=true
                        this.savingNew=false
                    })
                }else{
                    //pakai ini ary
                    this.errorNew=true
                    this.savingNew=false
                    this.errorList=[]
                    if(this.newTroubleshoot.nama==''){
                        this.errorList.push(["- Mohon isi nama pemilik bank"])
                    }
                    if(this.newTroubleshoot.no_rekening==''){
                        this.errorList.push(["- Mohon isi nomor rekening"])
                    }
                    if(this.newTroubleshoot.cabang==''){
                        this.errorList.push(["- Mohon isi nama cabang"])
                    }
                    if(this.newTroubleshoot.nama_bank==''){
                        this.errorList.push(["- Mohon isi nama bank"])
                    }
                    console.log(this.errorList)
                }
            },
            newUsernameChange(){
                this.newTroubleshoot.password = this.newTroubleshoot.username.toUpperCase();
            },
            deleteItem(item){
                console.log('button delete untuk user id: '+item.id)
            },
            updateUserRoleValue(newValue){
                this.newTroubleshoot.role=newValue
            },
            setNewClientId(newId){
                this.newTroubleshoot.clientId = newId;
                console.log(this.newTroubleshoot.clientId)
            },

            updateTroubleshootData(){
              console.log('updating data')
              this.updateTroubleshootState=true;
              this.errorTroubleshootSaved=false;
              axios.put(this.$baseUrl+'/api/troubleshoot/'+this.troubleshoots[this.selectedTroubleshoot].id,this.troubleshoots[this.selectedTroubleshoot],
              {
                  'headers':{
                      'Authorization':'Bearer '+localStorage.getItem('accessToken')
                  }
              }).then((result)=>{
                if(result.status==200){
                  this.updateTroubleshootState=false;
                  this.updateTroubleshootSaved=true;
                  //step 4 edit
                  this.dataEdit = this.troubleshoots[this.selectedTroubleshoot]
                  setTimeout(() => {
                      this.updateTroubleshootSaved=false;
                      this.$bvModal.hide('modal-edit-troubleshoot')
                  }, 1000);
                  console.log('yaya berhasil')
                }
              }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
                this.updateTroubleshootState=false;
                this.errorTroubleshootSaved=true;
                console.log(err.response)
              })
            },
            editModalClose(mdl){
                //step 2 edit
                this.$set(this.troubleshoots,this.selectedTroubleshoot,this.dataEdit)
                //step 3 edit
                this.dataEdit = Object.assign({},null)
              if(this.updateTroubleshootState){
                console.log('updating')
                mdl.preventDefault()
              }else{
                console.log('closing')
                mdl.hide('modal-edit-troubleshoot');
              }
            },
            deleteModalClose(mdl){
              if(this.deleteTroubelshootState){
                console.log('deleting')
                mdl.preventDefault()
              }else{
                console.log('closing')
                mdl.hide('modal-delete-user');
              }
            },
            detailModalClose(mdl){
              if(this.updateTroubleshootState){
                console.log('detail')
                mdl.preventDefault()
              }else{
                console.log('closing')
                mdl.hide('modal-detail-pengguna');
              }
            },

            deleteClientData(){
              console.log('deleting data')
              this.deleteTroubelshootState=true;
              axios.delete(this.$baseUrl+'/api/troubleshoot/'+this.troubleshoots[this.selectedToDelete].id,{
                  'headers':{
                      'Authorization':'Bearer '+localStorage.getItem('accessToken')
                  }
              }).then((result)=>{
                if(result.status==200){
                    this.deleteTroubelshootState=false;
                    this.userDeleted=true;
                    this.troubleshoots.splice(this.selectedToDelete, 1);
                    
                  setTimeout(() => {
                      this.$bvModal.hide('modal-delete-user');
                      this.userDeleted=false;
                  }, 1000);
                  console.log('yaya berhasil')
                }
              }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
                this.deleteTroubelshootState=false;
                this.failDeleteUser=true;
                setTimeout(() => {
                      this.failDeleteUser=false;
                  }, 1000);
                console.log(err)
              })
            },
        },
    }
</script>
<style scoped>
.btn {
    padding : 2px 6px;
}
::v-deep .modal.show .modal-dialog {
    transform: translate(0px, 10%);
}
::v-deep .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 10.5rem);
}
.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
    width: 50%;
}
</style>
